import { themeGet } from '@styled-system/theme-get';
import * as styledSystem from 'styled-system';
import { theme } from '@/providers/ThemeProvider/theme';

const { get: getKey } = styledSystem;

export const get = (key: string) => themeGet(key, getKey(theme, key));
